import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@mui/material';
import { WarningAmberRounded } from '@mui/icons-material';

/**
 * Reusable confirmation dialog — a styled replacement for window.confirm().
 *
 * <ConfirmDialog
 *   open={open}
 *   title="Withdraw this inquiry?"
 *   message="This removes it and you can start a fresh one."
 *   confirmLabel="Withdraw"
 *   confirmColor="error"
 *   loading={saving}
 *   onConfirm={doWithdraw}
 *   onCancel={() => setOpen(false)}
 * />
 */
export default function ConfirmDialog({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
  loading = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 700 }}>
        <WarningAmberRounded color={confirmColor === 'error' ? 'error' : 'warning'} />
        {title}
      </DialogTitle>
      {message && (
        <DialogContent>
          <DialogContentText sx={{ color: 'text.secondary' }}>{message}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading} sx={{ textTransform: 'none' }}>
          {cancelLabel}
        </Button>
        <Button onClick={onConfirm} disabled={loading} variant="contained" color={confirmColor}
          sx={{ textTransform: 'none', fontWeight: 700 }}>
          {loading ? 'Working…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
